import { render, staticRenderFns } from "./AttributePicker.vue?vue&type=template&id=04ec0d1a"
import script from "./AttributePicker.vue?vue&type=script&lang=js"
export * from "./AttributePicker.vue?vue&type=script&lang=js"
import style0 from "./AttributePicker.vue?vue&type=style&index=0&id=04ec0d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports